import React, { useEffect, useState, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@material-ui/core";

import WizardLayout from "../../components/WizardLayout";
import Loading from "../../components/Loading";
import WizardNavigation from "../../components/WizardNavigation";
import TermsBox from "../../components/TermsBox";

import { registerInsurancePolicy } from "../../redux/insurancePolicies";

import Modal from "../../components/Modal";
import SelfInspection from "../../components/SelfInspection";
import NoBearing from "../../components/NoBearing";

import { setPaymentMethod, fetchPaymentMethods } from "../../redux/payments";

import useWizardSteps from "../../hooks/useWizardSteps";
import "./style.scss";

const accountTypeMap = {
  CA: "DEBITO EN CAJA DE AHORRO",
  CC: "DEBITO EN CUENTA CORRIENTE",
};

const suggestion = (
  <span>
    <b>Seleccioná</b> el medio de pago
  </span>
);

export default function PaymentMethods() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchPaymentMethods());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { paymentMethods, registerLoading } = useSelector(
    ({ payments, insurancePolicies }) => ({
      paymentMethods: payments.methods,
      registerLoading: insurancePolicies.registerLoading,
    })
  );

  const { creditCards, accounts } = paymentMethods;

  const [activePaymentMethod, setActivePaymentMethod] = useState();
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [next, setNext] = useState(false);

  const nextAction = () => {
    if (acceptTerms && activePaymentMethod && insuranceName !== "AUTOMOTOR") {
      dispatch(registerInsurancePolicy());
    } else if (
      acceptTerms &&
      activePaymentMethod &&
      insuranceName === "AUTOMOTOR"
    ) {
      setOpen(true);
    } else {
      setNext(true);
    }
    return;
  };

  const handleClick = (key, paymentType, paymentData) => {
    setActivePaymentMethod(key);
    dispatch(
      setPaymentMethod({
        paymentType,
        paymentData,
      })
    );
  };

  const { insuranceName } = useSelector(({ insurances }) => ({
    insuranceName: insurances.selected && insurances.selected.insuranceName,
  }));

  const stepWizard = () => {
    if (insuranceName === ("INTEGRAL DE COMERCIO" || "MASCOTA")) {
      return 5;
    } else if (insuranceName === "AUTOMOTOR") {
      return 6;
    } else {
      return 4;
    }
  };

  const [activeStep] = useWizardSteps(stepWizard());

  const { userCarInsurance } = useSelector(({ carInsurance }) => ({
    userCarInsurance: carInsurance.userCarInsurance,
    carPreferencePay: carInsurance.userCarInsurance.carPreferencePay,
    isNew: carInsurance.userCarInsurance.isNew,
  }));

  const [open, setOpen] = useState(false);

  const renderModal = () => {
    return userCarInsurance.isNew === "true" ? (
      <NoBearing closeModal={closeModal} />
    ) : (
      <SelfInspection closeModal={closeModal} />
    );
  };

  const closeModal = (isOpen) => {
    setOpen(isOpen);
  };

  return (
    <>
      {open && <Modal closeModal={closeModal}>{renderModal()}</Modal>}
      {!registerLoading ? (
        <WizardLayout activeStep={activeStep} suggestion={suggestion}>
          <div className='Container-Summary row'>
            {insuranceName !== "AUTOMOTOR" ? (
              <div className='methodsContainer'>
                {creditCards &&
                  creditCards.map((cc, key) => {
                    const finalKey = `cc-${key}`;
                    return (
                      cc.maskedCardNumber && (
                        <Fragment key={finalKey}>
                          {cc.status.code === "NORMAL" && (
                            <div
                              key={finalKey}
                              className={
                                activePaymentMethod === finalKey
                                  ? `methodContainer active`
                                  : "methodContainer"
                              }
                              onClick={() =>
                                handleClick(finalKey, "creditCard", {
                                  creditCardAccount: {
                                    operationId: cc.accountId,
                                  },
                                })
                              }
                            >
                              <div className='dataContainer'>
                                <p>TARJETA DE CRÉDITO</p>
                                <span>{cc.maskedCardNumber}</span>
                                <br />
                                <span>
                                  {cc.brand.description.toUpperCase()}
                                </span>
                              </div>
                              <div className='imgContainer'>
                                <img
                                  src={require(`../../img/tc/${cc.brand.code}.png`)}
                                  alt=''
                                />
                              </div>
                            </div>
                          )}
                        </Fragment>
                      )
                    );
                  })}
                {accounts &&
                  accounts.map((acc, key) => {
                    const finalKey = `acc-${key}`;
                    return (
                      <Fragment key={finalKey}>
                        {acc.currency.code === "ARS" &&
                          (acc.isoProduct === "CA" ||
                            acc.isoProduct === "CC") && (
                            <div
                              key={finalKey}
                              className={
                                activePaymentMethod === finalKey
                                  ? `methodContainer active`
                                  : "methodContainer"
                              }
                              onClick={() =>
                                handleClick(finalKey, "accounts", {
                                  bukNumber: acc.cbu,
                                  product: {
                                    isoProduct: acc.isoProduct,
                                  },
                                })
                              }
                            >
                              <div className='dataContainer'>
                                <p>{accountTypeMap[acc.isoProduct]}</p>
                                <span>{`${acc.sBrachId}-${acc.operationId}-${acc.subAccount}`}</span>
                                <br />
                                <span>BANCO PATAGONIA</span>
                              </div>
                              <div className='imgContainer patagoniaImage'>
                                <img
                                  src={require(`../../img/tc/BancoPatagonia.png`)}
                                  alt=''
                                />
                              </div>
                            </div>
                          )}
                      </Fragment>
                    );
                  })}
              </div>
            ) : (
              <div className='methodsContainer'>
                {creditCards &&
                  userCarInsurance.carPreferencePay ===
                    "debitoTarjetaCredito" &&
                  creditCards.map((cc, key) => {
                    const finalKey = `cc-${key}`;
                    return (
                      cc.maskedCardNumber && (
                        <Fragment key={finalKey}>
                          {cc.status.code === "NORMAL" && (
                            <div
                              key={finalKey}
                              className={
                                activePaymentMethod === finalKey
                                  ? `methodContainer active`
                                  : "methodContainer"
                              }
                              onClick={() =>
                                handleClick(finalKey, "creditCard", {
                                  creditCardAccount: {
                                    operationId: cc.accountId,
                                  },
                                })
                              }
                            >
                              <div className='dataContainer'>
                                <p>TARJETA DE CRÉDITO</p>
                                <span>{cc.maskedCardNumber}</span>
                                <br />
                                <span>
                                  {cc.brand.description.toUpperCase()}
                                </span>
                              </div>
                              <div className='imgContainer'>
                                <img
                                  src={require(`../../img/tc/${cc.brand.code}.png`)}
                                  alt=''
                                />
                              </div>
                            </div>
                          )}
                        </Fragment>
                      )
                    );
                  })}
                {accounts &&
                  userCarInsurance.carPreferencePay === "debitoCuenta" &&
                  accounts.map((acc, key) => {
                    const finalKey = `acc-${key}`;
                    return (
                      <Fragment key={finalKey}>
                        {acc.currency.code === "ARS" &&
                          (acc.isoProduct === "CA" ||
                            acc.isoProduct === "CC") && (
                            <div
                              key={finalKey}
                              className={
                                activePaymentMethod === finalKey
                                  ? `methodContainer active`
                                  : "methodContainer"
                              }
                              onClick={() =>
                                handleClick(finalKey, "accounts", {
                                  bukNumber: acc.cbu,
                                  product: {
                                    isoProduct: acc.isoProduct,
                                  },
                                })
                              }
                            >
                              <div className='dataContainer'>
                                <p>{accountTypeMap[acc.isoProduct]}</p>
                                <span>{`${acc.sBrachId}-${acc.operationId}-${acc.subAccount}`}</span>
                                <br />
                                <span>BANCO PATAGONIA</span>
                              </div>
                              <div className='imgContainer patagoniaImage'>
                                <img
                                  src={require(`../../img/tc/BancoPatagonia.png`)}
                                  alt=''
                                />
                              </div>
                            </div>
                          )}
                      </Fragment>
                    );
                  })}
              </div>
            )}
            <TermsBox
              title='Términos y condiciones'
              setAcceptTerms={setAcceptTerms}
              acceptTerms={acceptTerms}
            >
              <Box fontSize={12} textAlign='justify'>
                Autorizo expresamente a debitar de la cuenta/tarjeta
                seleccionada precedentemente, el importe correspondiente al
                precio del seguro solicitado, comprometiéndome a tal efecto a
                mantener acreditados en dicha cuenta/tarjeta los fondos
                suficientes para proceder al pago. Por otra parte, declaro
                conocer y aceptar que la cobertura del seguro sólo se mantendrá
                vigente siempre que el resumen de cuenta en el que se registre
                el precio del seguro sea abonado en tiempo y forma. Los datos
                personales ingresados en esta solicitud revisten el carácter de
                declaración jurada, y sólo podrán ser utilizados para fines de
                registro, control y cumplimiento de las obligaciones derivadas
                de la presente solicitud y las que resulten consecuencia de la
                normativa específica del Banco Central de la República Argentina
                y restantes organismos administrativos (Conforme lo dispuesto
                por los artículos 5 inc. d) y e) y 6 de la Ley 25.326).
                Asimismo, declaro haber sido informado del derecho que poseo
                para acceder, rectificar y/o cancelar mis datos personales ante
                la AGENCIA DE ACCESO A LA INFORMACIÓN PÚBLICA (AAIP) o ante
                Banco Patagonia S.A.
                <strong>
                  {" "}
                  Por último, declaro haber sido informado del derecho que me
                  asiste para revocar la solicitud del producto o servicio aquí
                  solicitado, notificando dicha circunstancia al Banco de manera
                  fehaciente. La revocación mencionada será sin costo ni
                  responsabilidad alguna, dentro del plazo de diez (10) días
                  hábiles, siempre y cuando no haya hecho uso del producto o
                  servicio solicitado.{" "}
                </strong>
                Así las cosas, y a fin de dar cumplimiento a las Resoluciones de
                la Unidad de Información Financiera (UIF), presto conformidad
                para proporcionar a las Compañías de Seguros que correspondan,
                la información y/o documentación relativa a mis datos
                personales. La presente solicitud formará parte integrante del
                contrato de póliza
              </Box>
            </TermsBox>
            <WizardNavigation
              nextAction={nextAction}
              nextActionText='Finalizar'
            />
            {next && (
              <>
                {!acceptTerms && (
                  <Box
                    mt='16px'
                    display='flex'
                    justifyContent='flex-end'
                    color='red'
                  >
                    Tienes que aceptar los terminos y condiciones para continuar
                  </Box>
                )}
                {!activePaymentMethod && (
                  <Box
                    mt='16px'
                    display='flex'
                    justifyContent='flex-end'
                    color='red'
                  >
                    Debes seleccionar un medio de pago para continuar
                  </Box>
                )}
              </>
            )}
          </div>
        </WizardLayout>
      ) : (
        <Loading />
      )}
    </>
  );
}
